import type { SearchFilter, SearchFilterType } from '../../domain/model/Stream.types';
import type * as api from './generated/api';

export const toSearchFilterType = (input: 'account_id' | 'asset_id' | 'device_type'): SearchFilterType => {
    switch (input) {
        case 'asset_id':
            return 'ASSET_ID';
        case 'device_type':
            return 'DEVICE_TYPE';
        case 'account_id':
            return 'ACCOUNT_ID';
    }
};

export const toApiSearchFilterType = (input: SearchFilterType): 'account_id' | 'asset_id' | 'device_type' => {
    switch (input) {
        case 'ASSET_ID':
            return 'asset_id';
        case 'DEVICE_TYPE':
            return 'device_type';
        case 'ACCOUNT_ID':
            return 'account_id';
    }
};

export const toSearchFilter = (input: api.SearchFilter): SearchFilter => ({
    query: input.query,
    type: toSearchFilterType(input.type),
});

export const toApiSearchFilter = (item: SearchFilter): api.SearchFilter => ({
    query: item.query,
    type: toApiSearchFilterType(item.type),
});
